export default __webpack_public_path__ + "static/media/MDteam-automatons.3b54389c.md";